import dynamic from "next/dynamic";

export const DynamicHero032 = dynamic(() => import("./Hero032"), {
  suspense: true,
});
